<dsw-footer viessmannLogoUrl="/">
    <div version>
        <span data-testid="app-version">{{ 'PTC.APP' | translate }} v{{ environmentService.version }}</span>
    </div>
</dsw-footer>
